import { Handle, Position, type NodeProps } from '@xyflow/react';
import classNames from 'classnames';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { useRegisterNodeHeight } from '../../hooks/useRegisterNodeHeight';
import { useWorkflowContext } from '../../state/WorkflowContext';

export type LabelNodeData = {
  nodeType: 'labelNode';
};

const handleStyle = {
  background: 'transparent',
  border: 'none',
  width: 0,
  height: 0,
};

export const LabelNode = ({ id }: NodeProps) => {
  const { t } = useTranslation('global');
  const { pathNodeIds } = useWorkflowContext();
  const isInPath = pathNodeIds.has(id);
  const nodeReference = useRegisterNodeHeight<HTMLDivElement>(id);

  return (
    <div ref={nodeReference} className="flex h-[88px] items-center">
      <div
        className={classNames(
          'bg-background-primary-default text-content-primary title-m rounded px-8 py-4',
          isInPath && 'text-content-brand-default',
        )}
      >
        {t('approvalWorkflows.labelNode.whenARequestIsMade')}
      </div>
      <Handle
        style={handleStyle}
        type="source"
        id="rightHandle"
        position={Position.Right}
      />
      <Handle
        style={handleStyle}
        type="source"
        id="bottomHandle"
        position={Position.Bottom}
      />
    </div>
  );
};
